import { request } from '@/plugins/http';

/**
 * 导入ID
 * @param params
 * @returns {AxiosPromise}
 */
const uploadExcel = params => request('/diagnose/uploadExcel', params);


const downloadModal = params => request('/diagnose/downloadModal', params,'blob');

const getIds = params => request(`/diagnose/getIds?imei=${params.imei}`, params,'','get');
const setIds = params => request(`/diagnose/setIds`, params);



export {
    uploadExcel,downloadModal,getIds,setIds
};